import { useEffect, useState } from 'react'

import type { ChatOptions, ReceivedChatMessage } from '@livekit/components-core'
import { setupChat } from '@livekit/components-core'

import { useRoomContext } from '@/src/context'
import { useObservableState } from '@/src/hooks/internal'

import { useAppDispatch } from '@/src/store/hooks'
import { setChatMessages } from '@/src/store/slices/chat'

/**
 * The `useChat` hook provides chat functionality for a LiveKit room.
 * It returns a simple `send` function to send chat messages and an array of `chatMessages` to hold received messages.
 * It also returns a `update` function that allows you to implement message-edit functionality.
 * @remarks
 * It is possible to pass configurations for custom message encoding and decoding and non-default topics on which to send the messages.
 * @public
 */
export function useChat(options?: ChatOptions, isPiP: boolean = false) {
  const dispatch = useAppDispatch()

  const room = useRoomContext()
  const [setup, setSetup] = useState<ReturnType<typeof setupChat>>(null)

  const isSending = useObservableState(setup?.isSendingObservable, false)
  const chatMessages = useObservableState<ReceivedChatMessage[]>(setup?.messageObservable, [])

  useEffect(() => {
    const setupChatReturn = setupChat(room, options)
    setSetup(setupChatReturn)
  }, [room, options])

  console.log('setupsetupsetup: ', setup)

  return { send: setup?.send, chatMessages, isSending }
}
